import {Fragment} from "react";
import Portal from "../../../layout/Portal";
import Modal from "../../../layout/Modal";
import Button from "../../Button";
import React from "react";
import TextInput from "../../TextInput";

let modal = null;

export class PreHeader extends React.Component {

    constructor(props) {
        super(props);
        const parse = this.parse();
        this.state = {
            preheader: parse.preheader,
            tag: parse.tag
        };
    }

    parse = () => {
        const ret = {style: null, content: null};
        const dom = new DOMParser().parseFromString(this.props.value || "<html><head/><body/></html>", 'text/xml');
        let preheaderTag = dom.querySelector("div.preheader");
        ret.preheaderTag = preheaderTag;
        ret.tag = !!preheaderTag;

        if (preheaderTag) {
            ret.preheader = preheaderTag.innerHTML;
        } else {
            ret.preheader = null;
        }
        ret.document = dom;
        return ret;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.value !== prevProps.value) {
            const parse = this.parse();
            this.setState({preheader: parse.preheader, tag: parse.tag});
        }
    }

    render() {
        return <Fragment>
            <Portal>
                <Modal
                    ref={(selectTemplateModal) => modal = selectTemplateModal}
                    size="large"
                    header="Preheader"
                    disabled={this.props.disabled || this.props.isLoading}
                    buttons={[
                        {
                            text: "Mégse",
                            props: {color: "default", disabled: this.props.disabled || this.props.isLoading},
                            onClose: true,
                            onClick: async () => {
                                try {
                                    const r = this.parse();
                                    this.setState({preheader: r.preheader});
                                    modal && modal.hide();
                                } catch (e) {

                                }
                            }
                        },
                        {
                            text: "Mentés",
                            props: {color: "primary", disabled: this.props.disabled || this.props.isLoading},
                            onClose: true,
                            onClick: async () => {
                                try {
                                    const r = this.parse();
                                    r.preheaderTag.innerHTML = this.state.preheader;
                                    this.props.saveChanges && this.props.saveChanges(r.document.documentElement.outerHTML);
                                    modal && modal.hide();
                                } catch (e) {
                                    console.log(e);
                                }
                            }
                        },
                    ]}
                >
                    <div className="row form-row">
                        <div className="col-md-12">
                            <TextInput name="preheader" value={this.state.preheader || ''} label="Preheader tartalma" saveChanges={(field, preheader) => this.setState({preheader})}/>
                            <p className="help-block">
                                A Preheader egy olyan email tartalmi elem amit a Gmail jelenít meg. Itt lehet tovább olvasni róla: <a href="https://www.google.com/search?q=gmail+preheader&tbm=isch" target="_blank">Google</a>.
                            </p>
                        </div>
                    </div>
                </Modal>
            </Portal>
            <Button
                color="default"
                onClick={() => {
                    modal && modal.focus();
                }}
                icon="format_clear"
                tooltip={"Preheader"}
                disabled={this.props.disabled || this.props.isLoading || !this.state.tag}
            />
        </Fragment>
    }
}